import { Box, SxProps } from "@mui/material"
import { ReactNode } from "react"
import { Theme } from "@mui/system"

interface OreveFooterProps {
    children: ReactNode
    sx?: SxProps<Theme> | undefined
}

export const OreveFooter = ({ children, sx }: OreveFooterProps) => {
    return (
        <Box
            sx={{
                position: "fixed",
                right: 0,
                bottom: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "right",
                bgcolor: "white",
                width: "100vw",
                paddingTop: "10px",
                paddingX: "24px",
                paddingBottom: "10px",
                height: "60px",
                boxShadow: "0px 0px 50px 0px rgba(0, 0, 0, 0.05)",
                borderTop: "1px solid #F2F4F8",
                ...sx,
            }}
        >
            {children}
        </Box>
    )
}
